import { IExtendedSearchData } from "src/api/server/extended-search";
import { FilterSection } from "src/components/pages/search/filter-section";
import { ISearch } from "src/components/pages/search/search.types";
import { SortSection } from "src/components/pages/search/sort-section";
import { handleResetSearch } from "src/components/pages/search/store/actions";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { getDefaultRanking } from "./utils/get-default-ranking";

interface IFilterSortSectionsWrapper extends ISearch {
    data: IExtendedSearchData;
    resultCount: number | null;
    isLoading: boolean;
}

export const FilterSortSectionsWrapper = ({ data, resultCount, isLoading, onSearch }: IFilterSortSectionsWrapper) => {
    const {
        rankingsData: { rankings, relevanceRanking },
    } = data;
    const { country } = useRouterLocale();

    const onResetSearch = () => {
        const defaultRanking = getDefaultRanking(data);
        handleResetSearch({ sortDirection: defaultRanking.sortDirection, selectedRanking: defaultRanking, country: country, onSearch });
    };

    return (
        <>
            <FilterSection data={data} resultCount={resultCount} isLoading={isLoading} onReset={onResetSearch} onSearch={onSearch} />
            <SortSection
                resultCount={resultCount}
                rankings={rankings}
                relevanceRanking={relevanceRanking}
                onSearch={onSearch}
                userNumOfDownloads={data.userNumOfDownloads}
            />
        </>
    );
};
